import { GridColumns } from '@mui/x-data-grid-pro';
import { XGridOverflowCell } from 'app/components/Common/XGrid/cells/XGridOverflowCell';
import moment from 'moment-timezone';
import { TaskStatus } from 'app/models/Tasks/Tasks';
import { missingField } from 'app/constants';

export const displayStatusBadge = (statusId, flag) => {
  let taskStatus = '';
  switch (statusId) {
    case TaskStatus.New:
      taskStatus = 'New';
      break;
    case TaskStatus.Pending:
      if (flag) {
        taskStatus = 'Pending';
      }
      break;
    case TaskStatus.Cancelled:
      taskStatus = 'Cancelled';
      break;
    case TaskStatus.Completed:
      taskStatus = 'Completed';
      break;
    default:
      taskStatus = '';
      break;
  }
  return taskStatus;
};

export const ReportTaskView = (t): GridColumns => [
  {
    field: 'assignedTo',
    headerName: t('notification.reports.assignedTo'),
    width: 250,
    filterable: true,
  },
  {
    field: 'task',
    headerName: t('notification.reports.task'),
    width: 200,
    filterable: true,
  },
  {
    field: 'taskCategory',
    width: 200,
    headerName: t('notification.reports.taskCategory'),
    filterable: true,
  },
  {
    field: 'status',
    width: 250,
    headerName: t('notification.reports.status'),
    renderCell: XGridOverflowCell()(),
    filterable: true,
  },
  {
    field: 'dueDate',
    width: 200,
    headerName: t('notification.reports.dueDate'),
    filterable: true,
  },
  {
    field: 'createdBy',
    width: 250,
    headerName: t('notification.reports.createdBy'),
    filterable: true,
  },
];

export const ReportTaskViewVisibilityModel = {
  assignedTo: true,
  task: true,
  taskCategory: true,
  status: true,
  dueDate: true,
  createdBy: true,
};

export const flattenedTaskGridRow = (logs, userId) => {
  if (logs) {
    const logData = logs.map((log, index) => {
      //@Team - Remove unused checkDueData function
      const checkDueDate =
        log.taskStatusId === TaskStatus.Pending || log.taskStatusId === TaskStatus.New
          ? moment().isAfter(moment(log?.dueDate).endOf('day'))
          : false;
      var assignedTo = log.assignedToList.find(p => p.assignedToId === userId);
      return {
        id: index,
        assignedTo: assignedTo?.assignedToFirstName + ' ' + assignedTo?.assignedToLastName,
        task: log.taskName,
        dueDate: log.dueDate ? moment.tz(log.dueDate, 'America/Los_Angeles').format('L') : '',
        taskCategory: log.taskCategory,
        createdBy: log.createdByFirstName + ' ' + log.createdByLastName,
        status: log.taskStatusId ? displayStatusBadge(log.taskStatusId, true) : missingField,
      };
    });
    return logData;
  } else return [];
};
